<template>
  <div class="login-block">
    <ul>
      <li class="account-block">
        <img class="icon" src="@/assets/img/icon/member_icon.png" alt="" />
        <span>{{ account }}</span>
      </li>
      <li class="balance-block">
        <img class="icon" :src="getImgUrl()" alt="" />
        <span>{{ balance | amount | moneyHandler }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapHiddenList, mapList , mapDSList, mapOperList } from '@/setting'

export default {
  name: 'loginInfo',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      account: state => state.user.account,
      balance: state => state.user.balance
    })
  },
  mounted() {},
  methods: {
    getImgUrl() {
      const mapTable = mapList.concat(mapHiddenList)
      const oper = localStorage.getItem('oper')
      console.log(oper)
      const url = require('@/assets/img/icon/balance_v2_icon.png')
      // if (mapTable.includes(oper)) this.setFavIco()

      // *** 改設定前專案圖片路徑，因此註解 ***/
      // switch (true)  {
      //   case (mapDSList.includes(oper)):
      //     break
      //   default:
      //     // 雲端圖片路徑
      //     this.setFavIco(url)
      // }

      this.setFavIco(url)

      return url
    },
    /**
     * 修改Favico
     * @param defUrl 預設url
     */
    setFavIco(defUrl) {
      const dom = document.querySelectorAll('link[href*=\'/favicon.ico\']')
      const oper = localStorage.getItem('oper')
      const timestampSec = Math.floor(Date.now() / 1000)

      // *** 改設定前專案圖片路徑，因此註解 ***//
      // 雲端圖片路徑
      // dom.forEach((item) => {
      //   item.href = `/icon/oper/${oper}/favicon.ico`
      // })

      // 專案圖片路徑
      dom.forEach((item) => {
        item.href = mapOperList[oper] ? `/img/favicon/${mapOperList[oper].name}_favicon.ico?${timestampSec}` : defUrl
      })
    }
  }
}
</script>

<style scoped></style>
